/* eslint-disable complexity */
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { auth0Authenticator, AuthenticatorUser, Logger, ROUTES, CurrentUserCheck } from '@futrli/shared-services';

import {
  setCurrentAuthenticatedUserFulfilled,
  setCurrentAuthenticatedUserPending,
  setCurrentAuthenticatedUserRejected
} from '../../auth/redux-utils/actions';
import { DispatchAny, StoreState } from '../../core/types';
import { getTracker } from '../../core/injected';
import { isProdEnvironment } from '../../../../skeleton/src/utils/env-utils';
import { NavigateFunction } from 'react-router-dom';

const FORM_LOGIN_NAME = 'login';
const FORM_TRIAL_NAME = 'trial_demo';

export const setSageIdUser = (
  navigate: NavigateFunction,
  redirect: boolean,
  currentUser?: CurrentUserCheck,
  redirectRoute?: string,
  setupCompleted?: boolean
): DispatchAny => {
  return async (dispatch: ThunkDispatch<StoreState, unknown, Action>) => {
    try {
      dispatch(setCurrentAuthenticatedUserPending());

      const user: AuthenticatorUser = await auth0Authenticator.getCurrentAuthenticatedUser(currentUser);

      dispatch(setCurrentAuthenticatedUserFulfilled(user));

      const tracker = getTracker();
      tracker.resetIntercom();

      if (isProdEnvironment()) {
        if (setupCompleted) {
          window.utag?.link({
            event: 'form',
            event_name: 'form_submit_success',
            form_name: FORM_LOGIN_NAME
          });
        } else {
          window.utag?.link({
            event: 'form',
            event_name: 'form_submit_success',
            form_name: FORM_TRIAL_NAME
          });
        }
      }

      if (redirectRoute) {
        navigate(redirectRoute);
      }

      if (redirect) {
        navigate(ROUTES.ROOT_ROUTE);
      }
    } catch (e) {
      Logger.error(e as string);
      if (isProdEnvironment()) {
        if (setupCompleted) {
          window.utag?.link({
            event: 'form',
            event_name: 'form_submit_error',
            form_name: FORM_LOGIN_NAME
          });
        } else {
          window.utag?.link({
            event: 'form',
            event_name: 'form_submit_error',
            form_name: FORM_TRIAL_NAME
          });
        }
      }
      dispatch(setCurrentAuthenticatedUserRejected());
    }
  };
};
